/**
 * Optimizaciones de Zone.js para mejor rendimiento
 * Especialmente importante en dispositivos móviles
 */

// Deshabilitar Web Components (no se usan)
(window as any).__Zone_disable_customElements = true;

// Deshabilitar patching de eventos que no necesitamos
// Reduce overhead de Zone.js significativamente
(window as any).__Zone_disable_requestAnimationFrame = true; // Ya no se usa mucho
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'scroll',     // No necesitamos change detection en scroll
  'mousemove',  // No necesitamos change detection en mousemove
  'mouseenter',
  'mouseleave',
  'touchmove',  // Crítico para performance en mobile
  'touchstart',
  'touchend'
];
